import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing Webix TinyMCE module
import { persons } from '../../../models/persons'; // Importing persons model
import { devConfig } from '../../../config/config'; // Importing development configuration

export default class InformationView extends JetView {
    // Defining InformationView class extending JetView
    config() {
        // Configuration method for the view
        const _ = this.app.getService('locale')._; // Localization service for translations
        const main_info = {
            // Main information layout configuration
            view: 'scrollview', // Scrollable view
            container: 'toolbar', // Container for the toolbar
            scroll: 'x', // Horizontal scrolling
            body: {
                // Body of the scrollview
                margin: 20, // Margin around the body
                width: screen.width < 500 ? 500 : 0, // Conditional width based on screen size
                cols: [
                    // Columns layout
                    {
                        margin: 10, // Margin for the column
                        rows: [
                            // Rows within the column
                            {
                                view: 'text', // Text input for Total Deposit
                                name: 'TotalDeposit', // Name of the input
                                label: _('Total Depósitos'), // Label for the input
                                labelPosition: 'top', // Position of the label
                                placeholder: _('Total Depósitos'), // Placeholder text
                                disabled: true, // Input is disabled
                            },
                            {
                                view: 'text', // Text input for Total Sport Stakes
                                name: 'TotalSportStakes', // Name of the input
                                label: _('Total Apuestas Deportivas'), // Label for the input
                                labelPosition: 'top', // Position of the label
                                placeholder: _('Total Apuestas Deportivas'), // Placeholder text
                                disabled: true, // Input is disabled
                            },
                            {
                                view: 'text', // Text input for Total Sport Winnings
                                name: 'TotalSportWinnings', // Name of the input
                                label: _('Total Ganancias Deportivas'), // Label for the input
                                labelPosition: 'top', // Position of the label
                                placeholder: _('Total Ganancias Deportivas'), // Placeholder text
                                disabled: true, // Input is disabled
                            },
                            {
                                view: 'text', // Text input for Total Casino Stakes
                                name: 'TotalCasinoStakes', // Name of the input
                                label: _('Total Apuestas Casino'), // Label for the input
                                labelPosition: 'top', // Position of the label
                                placeholder: _('Total Apuestas Casino'), // Placeholder text
                                disabled: true, // Input is disabled
                            },
                            {
                                view: 'text', // Text input for Total Casino Winnings
                                name: 'TotalCasinoWinnings', // Name of the input
                                label: _('Ganancias Totales Casino'), // Label for the input
                                labelPosition: 'top', // Position of the label
                                placeholder: _('Ganancias Totales Casino'), // Placeholder text
                                disabled: true, // Input is disabled
                            },
                            {
                                view: 'text', // Text input for Total Withdrawal
                                name: 'TotalWithdrawal', // Name of the input
                                label: _('Total Retiros'), // Label for the input
                                labelPosition: 'top', // Position of the label
                                placeholder: _('Total Retiros'), // Placeholder text
                                disabled: true, // Input is disabled
                            },
                            {
                                view: 'text', // Text input for Adjustment E
                                name: 'AdjustmentE', // Name of the input
                                label: _('Total Ajustes Entrada'), // Label for the input
                                labelPosition: 'top', // Position of the label
                                placeholder: _('Total Ajustes Entrada'), // Placeholder text
                                disabled: true, // Input is disabled
                            },
                            {
                                view: 'text', // Text input for Adjustment S
                                name: 'AdjustmentS', // Name of the input
                                label: _('Total Ajustes Salida'), // Label for the input
                                labelPosition: 'top', // Position of the label
                                placeholder: _('Total Ajustes Salida'), // Placeholder text
                                disabled: true, // Input is disabled
                            },
                            {
                                height: 0, // Empty row for spacing
                            },
                        ],
                    },
                    {
                        margin: 20, // Margin for the column
                        width: screen.width < 500 ? 300 : 0, // Conditional width based on screen size
                        cols: [
                            // Columns layout
                            {
                                margin: 10, // Margin for the column
                                id: 'templateCol', // ID for the column
                                rows: [
                                    // Rows within the column
                                    {
                                        view: 'template', // Template view for loading indicator
                                        id: 'templateResume', // ID for the template
                                        // HTML template for loading indicator
                                        template:
                                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        };
        const main_info2 = {
            // Secondary main information layout configuration
            view: 'scrollview', // Scrollable view
            container: 'toolbar', // Container for the toolbar
            scroll: 'xy', // Both horizontal and vertical scrolling
            body: {
                // Body of the scrollview
                cols: [
                    // Columns layout
                    {
                        cols: [
                            // Nested columns layout
                            {
                                margin: 10, // Margin for the column
                                id: 'templateCol', // ID for the column
                                rows: [
                                    // Rows within the column
                                    {
                                        view: 'template', // Template view for loading indicator
                                        id: 'templateResume', // ID for the template
                                        // HTML template for loading indicator
                                        template:
                                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        };
        const upper_section = {
            // Upper section layout configuration
            id: 'a1', // ID for the section
            rows: [
                // Rows within the section
                {
                    margin: 30, // Margin for the row
                    responsive: 'a1', // Responsive behavior
                    cols: [main_info], // Including main_info layout
                },
            ],
        };
        const upper_section2 = {
            // Upper section layout configuration for second view
            id: 'a1', // ID for the section
            rows: [
                // Rows within the section
                {
                    margin: 30, // Margin for the row
                    responsive: 'a1', // Responsive behavior
                    cols: [main_info2], // Including main_info2 layout
                },
            ],
        };
        const detailsCasino = webix.ui({
            // Configuration for the detailsCasino window
            view: 'window', // Window view
            move: true, // Allow window to be moved
            id: 'detailsCasino', // ID for the window
            fullscreen: true, // Fullscreen mode
            head: {
                // Header of the window
                view: 'toolbar', // Toolbar view
                cols: [
                    // Columns in the toolbar
                    {
                        view: 'label', // Label for the title
                        label: _('Detalles Avanzados'), // Title text
                        align: 'center', // Center alignment
                    },
                    {
                        view: 'icon', // Icon for closing the window
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide(); // Hides the window
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                // Body of the window
                view: 'form', // Form view
                id: 'dtDetails2', // ID for the form
                type: 'clean', // Clean form type
                padding: 10, // Padding for the form
                rows: [upper_section2], // Including upper_section2 layout
            },
        });
        webix.ui.fullScreen(); // Enable fullscreen mode for Webix UI
        return {
            // Return the main configuration object
            view: 'form', // Form view
            id: 'formDetails', // ID for the form
            rows: [
                // Rows within the form
                screen.width > 500 && screen.height > 500 // Conditional rendering based on screen size
                    ? upper_section // Include upper_section if conditions are met
                    : { height: 1, width: 0 }, // Empty row if conditions are not met
            ],
            rules: {
                // Validation rules for the form
                fname: webix.rules.isNotEmpty, // Rule to ensure fname is not empty
            },
        };
    }
    init(form) {
        // Initialization method for the view
        const _ = this.app.getService('locale')._; // Localization service for translations
        this.on(this.app, 'customer:updateFinance', (id) => {
            // Event listener for updating finance
            const test = this; // Reference to the current instance
            webix // AJAX request to fetch client KPI data
                .ajax()
                .get(
                    devConfig.geturlApi() + 'Client/GetClientKpi', // API endpoint
                    'id=' + id, // Query parameter
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error callback
                            webix.message('Error! '); // Display error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success callback
                            text = JSON.parse(text); // Parse the response text
                            var shtml = // HTML string for displaying summary
                                '<div style=" width: 100%;height: 100%;overflow: scroll;"> <h2>' +
                                _('Resumen') +
                                '</h2> ' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Depositos:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalDeposit) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Apuestas en Deportivas:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalSportStakes) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Apuestas en Casino:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalCasinoStakes) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Total Apuestas:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalCasinoStakes + text[0].TotalSportStakes) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Premios en Deportivas:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalSportWinnings) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Premios en Casino:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalCasinoWinnings) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Total Premios:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalSportWinnings + text[0].TotalCasinoWinnings) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Notas pendientes:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalPendingWithdrawal) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Valor Retirado:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalWithdrawal) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Bonos:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalBonus) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Bonos Free Ganados:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; float: right; "></div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].TotalBonusWin) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Ajustes Entrada:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].AdjustmentE) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Ajustes Salida:') +
                                ' </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(text[0].AdjustmentS) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('GGR:') +
                                ' </div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(
                                    text[0].TotalCasinoStakes +
                                        text[0].TotalSportStakes -
                                        (text[0].TotalSportWinnings + text[0].TotalCasinoWinnings),
                                ) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">' +
                                _('Rejuego:') +
                                ' </div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(
                                    (text[0].TotalCasinoStakes + text[0].TotalSportStakes) / text[0].TotalDeposit,
                                ) +
                                '</div>  </div>' +
                                '<div style=" width: 100%; padding: 5px 0px;font-weight: bold;"> <div style=" display: inline-block; ">' +
                                _('Total:') +
                                ' </div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                                webix.i18n.priceFormat(
                                    (
                                        text[0].TotalDeposit -
                                        text[0].TotalSportStakes -
                                        text[0].TotalCasinoStakes +
                                        text[0].TotalSportWinnings +
                                        text[0].TotalCasinoWinnings -
                                        text[0].TotalPendingWithdrawal -
                                        text[0].TotalWithdrawal +
                                        text[0].TotalBonus +
                                        text[0].AdjustmentE -
                                        text[0].AdjustmentS
                                    ).toFixed(2),
                                    { decimalSize: 2 },
                                ) +
                                '</div>  </div>' +
                                '</div>';
                            $$('templateResume').setHTML(shtml); // Set the HTML content of the template
                            $$('templateCol').hide(); // Hide the template column
                            $$('templateCol').show(); // Show the template column
                            test.app.callEvent('customer:updatedataFinance', [
                                // Trigger event to update finance data
                                text[0],
                            ]);
                        },
                    },
                );
        });
        this.on(this.app, 'resume:id', (Id) => {
            // Event listener for resume event
            this.app.callEvent('customer:updateFinance', [Id]); // Trigger finance update with the given ID
        });
        this.on(
            this.app,
            'customer:updatedataFinance',
            (
                person, // Event listener for updating finance data
            ) => form.setValues(person), // Set form values with the updated person data
        );
    }
    getLocalizedComboOptions() {
        // Method to get localized options for combo boxes
        const _ = this.app.getService('locale')._; // Localization service for translations
        let p_options = webix.copy(getPositions()); // Copy positions data
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parse positions into the combo box
        let t_options = webix.copy(getTags()); // Copy tags data
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parse tags into the combo box
        let c_options = webix.copy(getCities()); // Copy cities data
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parse cities into the combo box
    }
}

// FILE DOCUMENTED
